module.exports = __webpack_public_path__ + "static/media/feature_nlp_engine.c3edb900.png";